import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonCommon',
  props: {
    color: { default: "" },
    type: { default: "" },
    icon: { type: Boolean, default: false },
    onImage: { type: Boolean, default: false },
    map: { type: Boolean, default: false },
    text: { default: "" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    appendIcon: { default: "" },
    iconSize: { default: 24 },
    iconColor: { default: "" },
    block: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    smallPadding: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: Event): void
}), expose: any, slots: any, attrs: any }) {






function buttonClick(event: Event) {
  emit('click', event)
}


return { __sfc: true,emit, buttonClick }
}

})